import { render, staticRenderFns } from "./EventDisplayModal.vue?vue&type=template&id=cba2b2e4&scoped=true"
import script from "./EventDisplayModal.vue?vue&type=script&lang=js"
export * from "./EventDisplayModal.vue?vue&type=script&lang=js"
import style0 from "./EventDisplayModal.vue?vue&type=style&index=0&id=cba2b2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba2b2e4",
  null
  
)

export default component.exports